/* Aura language helper — Markets URLs (/ and /en) are canonical.
   Clears the old client-side fallback so it cannot mangle sentences. */
(function () {
  try {
    if (localStorage.getItem('aura_lang')) {
      localStorage.removeItem('aura_lang');
    }
  } catch (e) {}
})();
